import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { RadioField } from "../DynamicFormTypes";
import { UseFormReturn } from "react-hook-form";
import { LassoTextField } from "../../LassoTextField";
import { ChangeEvent, useEffect } from "react";

type Props = {
    field: RadioField;
    form: UseFormReturn;
}

const RadioInput = ({ field, form }: Props) => {
    const { name, label, defaultValue = "", options = [], numRows = 1, numColumns = 1 } = field;
    const formValue = form.watch(name);
    useEffect(() => {
        if(!formValue){
            const isDefaultDynamic = options.filter((option) => option.dynamic && option.value === defaultValue).length > 0;
            const test = {
                selected: defaultValue,
                value: isDefaultDynamic ? "" : defaultValue
            }
            form.setValue(name, test);
        }
    }, []);

    const DynamicRadioOption = ({ value, label, disabled }: {value: string, label: string, disabled?: boolean}) => {
        const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
            form.setValue(name, { selected: value, value: event.target.value });
        }
        return <Stack flexDirection="row" gap={3}>
            <FormControlLabel value={value} control={<Radio />} label={label} disabled={disabled || false} />
            <LassoTextField
                value={formValue?.selected === value ? formValue?.value : ""}
                onChange={handleChange}
                disabled={formValue?.selected !== value}
                autoFocus //This is a hack to regain focus since this component re-renders every time it changes value
            />
        </Stack>
    }

    return (
        <FormControl fullWidth sx={{ alignSelf: 'flex-start' }}>
            <FormLabel>{label}</FormLabel>
            <RadioGroup
                sx={{
                    display: 'grid',
                    gridTemplateRows: `repeat(${numRows}, minmax(auto, max-content))`,
                    gridTemplateColumns: `repeat(${numColumns}, minmax(auto, max-content))`,
                }}
                aria-labelledby={`${label}-radio-buttons-group-label`}
                defaultValue={defaultValue}
                value={formValue?.selected || ""}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    form.setValue(name, { selected: event.target.value, value: event.target.value });
                }}
            >
                {options.map(
                    (option) => option.dynamic
                        ? <DynamicRadioOption key={option.value} value={option.value}  label={option.label} disabled={option.disabled || false} />
                        : <FormControlLabel disabled={option.disabled || false} key={option.value} value={option.value} control={<Radio />} label={option.label}/>
                )}
            </RadioGroup>
        </FormControl>
    )
}

export default RadioInput;